import { reduxForm, formValueSelector } from 'redux-form';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { onSubmit, onSubmitSuccess, onSubmitFail } from './ChooseUserName.submit';
import { ChooseUserNameScreen } from './ChooseUserNameScreen';
import { validate } from './ChooseUserName.validate';
import { navigateToScreen } from 'actionCreators/navigation';
import { updateCase, showUserNameExists } from 'actionCreators/case';
import { showHideLoader } from 'actionCreators/loader';

const ChooseUserNameForm = reduxForm({
  form: 'ChooseUserNameForm',
  validate,
  onSubmit,
  onSubmitSuccess,
  onSubmitFail,
  destroyOnUnmount: false,
  enableReinitialize: true,
  forceUnregisterOnUnmount: true
})(ChooseUserNameScreen);

const selector = formValueSelector('ChooseUserNameForm');

const getUserName = (state) => {
  const {
    customer: { customerInfo },
    caseDetails
  } = state;

  if (!customerInfo && !caseDetails.caseInfo) {
    return null;
  }
  const {
    caseInfo: {
      applicants: {
        user_details: { username }
      }
    },
    isUserNameSubmitted
  } = caseDetails;

  return {
    userName:
      username || isUserNameSubmitted
        ? selector(state, 'userName') || username
        : customerInfo && customerInfo.contact_details.email,
    secondaryUserName:
      username || isUserNameSubmitted
        ? selector(state, 'secondaryUserName') || username
        : customerInfo && customerInfo.contact_details.email
  };
};

export const isUserNameAlreadyChoosen = (caseDetails) => {
  const {
    caseInfo: {
      applicants: {
        user_details: { username }
      }
    },
    isUserNameSubmitted
  } = caseDetails;

  return !!username || isUserNameSubmitted;
};

const ChooseUserNameContainer = connect(
  (state) => ({
    config: state.config,
    formState: state.form,
    loanValues: state.loanValues,
    caseDetails: state.caseDetails,
    customerInfo: state.customer.customerInfo,
    loader: state.loader,
    isUserNameChoosen: isUserNameAlreadyChoosen(state.caseDetails),
    initialValues: getUserName(state),
    isSecondaryApplicant: state.config.isSecondaryApplicant,
    newIncome: state.customer?.newIncome,
    financialCircumstanceValue: state.customer?.financialCircumstanceValue
  }),
  (dispatch) =>
    bindActionCreators(
      { updateCase, showHideLoader, showUserNameExists, navigateToScreen },
      dispatch
    )
)(ChooseUserNameForm);

export { ChooseUserNameContainer };
